module.exports = __webpack_public_path__ + "static/media/modinet_left_side-002.e310fc4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/modinet_left_side-002.jpg
// module id = 572
// module chunks = 0